module.exports = __webpack_public_path__ + "img/home-improvements.4368d11c.png";